export const alloysPartnersShopifyAppGroupIdBridgesBridgeIdBackfillEstimates =
  "/alloys/partners/shopify/:app_group_id/bridges/:bridge_id/backfill_estimates";
